import { ITaggingFlowOption } from 'interfaces/tagging/ITaggingFlowOption';
import { CallTypes } from '@trackman/baseball-shared-components';
import React from 'react';
import { FieldableTooltipContent } from './tooltips/FieldableTooltipContent';

export const CallOptions: ITaggingFlowOption[] = [
  {
    displayName: 'Ball Called',
    value: CallTypes.BallCalled,
    hotkeyCode: 66,
    hotkeyDisplay: 'B',
  },
  {
    displayName: 'Ball Intentional',
    value: CallTypes.BallIntentional,
    hotkeyCode: 73,
    hotkeyDisplay: 'I',
  },
  {
    displayName: 'Strike Called',
    value: CallTypes.StrikeCalled,
    hotkeyCode: 83,
    hotkeyDisplay: 'S',
  },
  {
    displayName: 'Strike Swinging',
    value: CallTypes.StrikeSwinging,
    hotkeyCode: 87,
    hotkeyDisplay: 'W',
  },
  {
    displayName: 'Ball in Dirt',
    value: CallTypes.BallinDirt,
    hotkeyCode: 68,
    hotkeyDisplay: 'D',
  },
  {
    displayName: 'Foul Ball - fieldable',
    value: CallTypes.FoulBallFieldable,
    hotkeyCode: 89,
    hotkeyDisplay: 'Y',
    tooltipContent: <FieldableTooltipContent />,
  },
  {
    displayName: 'Foul Ball - not fieldable',
    value: CallTypes.FoulBallNotFieldable,
    hotkeyCode: 90,
    hotkeyDisplay: 'Z',
  },
  {
    displayName: 'Hit By Pitch',
    value: CallTypes.HitByPitch,
    hotkeyCode: 72,
    hotkeyDisplay: 'H',
  },
  {
    displayName: 'In Play',
    value: CallTypes.InPlay,
    hotkeyCode: 80,
    hotkeyDisplay: 'P',
  },
];
